import script from "./PanelCollapse.vue?vue&type=script&setup=true&lang=ts"
export * from "./PanelCollapse.vue?vue&type=script&setup=true&lang=ts"

import "./PanelCollapse.vue?vue&type=style&index=0&id=7c4daf9e&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c4daf9e"]])

export default __exports__